<template>
  <a-config-provider :locale="locale">
    <router-view />
  </a-config-provider>
</template>
<style lang="less">
  @import '~@/assets/css/descriptions.css';
</style>
<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
export default {
  data() {
    return {
      locale: zhCN,
    };
  }
}
</script> 
<style lang="less" scoped>
#app {
  height:100%;
}
</style>
